import config from "@/config";
import useDialog from "./useDialog";
import { BottomDrawerTransition, MobileOptionsDialog } from "@/Components";

export default function useMobileOptionsDialog() {
    const { forceClose, toggleDialog } = useDialog();

    const toggleMobileOptionsDialog = (event, data) => {
        toggleDialog(
            MobileOptionsDialog,
            BottomDrawerTransition,
            data,
            event,
            config.dialogs.drawers.productSearchDialog.zindex,
            true
        );
    };

    return {
        forceClose,
        toggleMobileOptionsDialog,
    };
}
